<template>
  <div class="title-container">
    <div class="title-content">
      <springText class="item-title" text="Bounty Cases"></springText>
    </div>
    <fadeInAnimation>
      <div class="sub-title">
        Open Bounty Cases (requires $FIRE and a key) to obtain exclusive weapon skin NFTs and random Spark drops, which
        can also be sold in the marketplace.
      </div>
      <div class="case-icon">
        <img src="@/assets/images/playDetails/caseWeapon/case_icon.png" alt="">
      </div>
    </fadeInAnimation>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
import springText from "@/views/components/springText";
import fadeInAnimation from "@/views/components/fadeInAnimation";

export default {
  mixins: [responsiveMixin],
  components: { springText, fadeInAnimation },
  data() {
    return {};
  },
  mounted() { },
  methods: {},
  watch: {

  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>